import { useFormik } from "formik";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import * as yup from "yup";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import { useState } from "react";
import { NuInput, NuMobileNumber, NuSelect, NuTextArea, NuUpload, SupplierNuInput } from "../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";

const CreateAgents = () => {
  const { value: Type, getData: refType } = useFetchMataData(`/dropdown/dropdown-details/`, 'AgentType')
  const { value: Designation, getData: refDesignation } = useFetchMataData(`/dropdown/dropdown-details/`, 'AgentDesignation')
  const { value: Rating } = useFetchMetaStar(`/dropdown/dropdown-details/`, 'AgentRating')
  // const [loading, setLoading] = useState(false);

  const { Oncancel, addFormData, isLoading } = useAddFormData();
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [servicesList, setServicesList] = useState([]);
  const servicesString = servicesList.join(', ');
  const [createNew, setCreateNew] = useState({
    type: "",
    companyName: "",
    email: "",
    phone: "",
    countryCode: "",
    website: "",
    billingAddress: "",
    shippingAddress: "",
    crNum: "",
    vatNum: "",
    ratings: "",
    comments: "",
    country: "",
    city: "",
    state: "",
    district: "",
    postalCode: "",
    cpName: "",
    cpEmail: "",
    cpDesignation: "",
    cpCountryCode: "",
    cpPhone: "",
    services: ""
  });

  const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      phone: yup.string()
        .matches(/^\d+$/, "Phone number must contain only digits")
        .min(9, "Phone number must be at least 9 digits")
        .max(11, "Phone number must be at most 11 digits")
        .required("Phone number is required"),
      email: yup.string().required('Email is required!'),
      companyName: yup.string().required('Company Name is required!'),
      cpName: yup.string().required('Contact Person Name is required!'),
      cpPhone: yup.string()
        .matches(/^\d+$/, "Phone number must contain only digits")
        .min(9, "Phone number must be at least 9 digits")
        .max(11, "Phone number must be at most 11 digits")
        .required("Phone number is required"),
      cpEmail: yup.string().required('Contact Person Email is required!'),
      cpDesignation: yup.string().required('Contact Person Designation is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      // setLoading(true); 
      let formData = new FormData();
      const valueWithProducts = {
        ...value,
        services: servicesString
      };
      formData.append("agentDetails", JSON.stringify(valueWithProducts));
      formData.append('agentImage', image.raw);

      addFormData("/agents/new-agent", formData, resetForm);
      // setLoading(false)
    },
  });

  const handleAddServices = () => {
    const services = formik.values.services.split(',').map((p) => p.trim()).filter(Boolean);
    setServicesList((prevList) => [...prevList, ...services]);
    formik.setFieldValue('services', '');
  };

  const handleDeleteServices = (index) => {
    setServicesList((prevList) => prevList.filter((_, i) => i !== index));
  };

  return (
    <div className="w-full h-full p-2 lg:px-4">
      <div className="w-full flex flex-row justify-between items-center gap-2 mb-3">
        <Breadcrumb
          items={
            [
              {
                name: "Shipping",
                link: "/shipping/agents"
              },
              {
                name: "Shipping Agent",
                link: "/shipping/agents"
              },
              {
                name: "Create Agents"
              }]
          }
        />
        <div className="flex items-center gap-2 flex-shrink-0">
          <BackButton />
        </div>
      </div>
      <div className="w-full min-h-[calc(100vh-140px)] h-auto md:h-[calc(100vh-140px)] overflow-y-auto">
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full mx-auto bg-white rounded-md pb-4">
            <div className="w-full h-full flex justify-start content-start flex-wrap px-2 mb-4">

              <div className="w-full">
                <p className='pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4'>
                  Agent Details :
                </p>
              </div>
              <DropDownAddMetaData
                label="Agent Type"
                placeholder="Choose"
                Options={Type}
                formik={formik}
                name="type"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refType}
                displayProperty={"Agent Type"}
                propertyName={"AgentType"}
              />

              <NuInput
                type="text"
                label="Company Name"
                placeholder="Company Name"
                formik={formik}
                name="companyName"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuMobileNumber
                nunCode="countryCode"
                label="Phone"
                placeholder="Phone"
                formik={formik}
                name="phone"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="email"
                label="Email"
                placeholder="Email"
                formik={formik}
                name="email"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="website"
                placeholder="Website"
                formik={formik}
                name="website"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="text"
                label="Contact Person Name"
                placeholder="CPName"
                formik={formik}
                name="cpName"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuMobileNumber
                nunCode="cpCountryCode"
                label="Contact Person Phone"
                placeholder="Contact Person Phone"
                formik={formik}
                name="cpPhone"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="email"
                label="Contact Person Email"
                placeholder="CPEmail"
                formik={formik}
                name="cpEmail"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <DropDownAddMetaData
                label="Contact Person Desigation"
                placeholder="Choose"
                Options={Designation}
                formik={formik}
                name="cpDesignation"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refDesignation}
                displayProperty={"Contact Person Desigation"}
                propertyName={"AgentDesignation"}
              />




              <NuInput
                type="number"
                label="CRNum"
                placeholder="CRNum"
                formik={formik}
                name="crNum"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="number"
                label="Vat Num"
                placeholder="Vat Num"
                formik={formik}
                name="vatNum"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <FormikSelectTwo
                type="text"
                label="Ratings"
                placeholder="Choose"
                Options={Rating}
                formik={formik}
                name="ratings"
                width="w-full md:w-1/2 lg:w-1/3"
              />
            </div>
          </div>
          <div className="w-full mx-auto px-2  bg-white rounded-md pb-4 mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">

              <div className="w-full">
                <p className='pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4'>
                  Address
                </p></div>
              <NuTextArea
                type="text"
                label="Billing Address"
                placeholder="Billing Address"
                formik={formik}
                name="billingAddress"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuTextArea
                type="text"
                label="Shipping Address"
                placeholder="Shipping Address"
                formik={formik}
                name="shippingAddress"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="text"
                label="Country"
                placeholder="Country"
                formik={formik}
                name="country"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="text"
                label="State"
                placeholder="State"
                formik={formik}
                name="state"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="text"
                label="District"
                placeholder="District"
                formik={formik}
                name="district"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="text"
                label="City"
                placeholder="City"
                formik={formik}
                name="city"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="number"
                label="Postal Code"
                placeholder="Postal Code"
                formik={formik}
                name="postalCode"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuTextArea
                label="Comments"
                placeholder="Comments"
                formik={formik}
                name="comments"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuUpload
                label="Attachment"
                width="w-full md:w-1/2 lg:w-1/3"
                onChange={handleChangeImg}
              />
            </div>
          </div>
          <div className="w-full mx-auto  bg-white rounded-md pb-4 mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">

              <div className="w-full">
                <p className='pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4'>
                  Services
                </p></div>
              <div className="w-full sm:w-1/2 lg:w-1/3 flex flex-col px-2 sm:px-4">
                <div className="flex justify-start">
                  <SupplierNuInput
                    type="text"
                    placeholder="separate services with ','"
                    formik={formik}
                    name="services"
                    width="w-11/12"
                  />
                  <button
                    onClick={handleAddServices}
                    type="button"
                    className="mt-4 w-10 h-10 text-center cursor-pointer bg-[#048178] border border-solid border-white text-white font-semibold rounded-md"
                  >
                    +
                  </button>
                </div>
                <div className="w-11/12 h-28 ml-0 sm:ml-[8%] bg-[#f5f3ff] border-gray-300 rounded-md p-1 flex flex-col border border-solid overflow-y-scroll mt-2">
                  {servicesList.map((word, index) => (
                    <span key={index} className="m-1 flex justify-between items-center text-xs bg-white border border-gray-300 rounded text-main-title py-2 px-2 hover:bg-[#B3EBD7] hover:bg-opacity-50">
                      {word}
                      <span
                        onClick={() => {
                          handleDeleteServices(index);
                        }}
                        className="text-blue-900 cursor-pointer"
                      >
                        x
                      </span>
                    </span>
                  ))}
                </div>
              </div>
              <div className="w-full mx-auto my-4 mt-8 px-2">
                <div className="flex justify-end gap-3 sm:gap-4">
                  <CancelButton handleClick={() => { Oncancel(-1) }} />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateAgents;
